<!--1-abecera para acciones de tareas en modo modal windowHash && !task: {{windowHash}}-->
<ng-container *ngIf="windowHash; else noModal">
  <!-- cabecera para acciones de tareas en modo modal -->
  <sub-header [isModal]="true" [includeContextHelp]="true" [windowHash]="windowHash">
    <!--- La pantalla es: isModal = true

    2-cabecera para acciones de tareas en modo modal windowHash: {{windowHash}}-->
  </sub-header>
  <ng-container *ngTemplateOutlet="dlgTemplates"></ng-container>
  <p-scrollPanel [style]="{width: '100%', height: '70vh'}" styleClass="custombar1 projectInHeader">
    <!-- <ng-container
      *ngTemplateOutlet="templateClassification;
      context: {tenderLotClassificationsTableRowModelParam: this.tenderLotClassificationsTableRowModel}"></ng-container>-->
    <div class="container-fluid">
      <ng-container *ngTemplateOutlet="recorremosMap2"></ng-container>
    </div>

  </p-scrollPanel>
</ng-container>

<ng-template #noModal>
  <div class="wrapper wrapper-content">
    <!-- La pantalla es: noModal -->

    <!--<ng-container *ngTemplateOutlet="templateClassification;
    context: {tenderLotClassificationsTableRowModelParam: this.tenderLotClassificationsTableRowModel}"></ng-container>

    <ng-container *ngTemplateOutlet="recorremosMap"></ng-container>
    <ng-container *ngTemplateOutlet="example_Expandable_Row_Groups"></ng-container>-->
    <div class="container-fluid">
      <ng-container *ngTemplateOutlet="recorremosMap2"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #templateClassification let-classificationList="tenderLotClassificationsTableRowModelParam">
  <!-- Entramos en : #templateClassification -->
  <div class="row">
    <div class="col-12 p-0 scroll-x">
      <!--<div
      *ngIf="(classificationList && classificationList[0] !== undefined && classificationList[0] !== null); else noClassification"
      class="row p-3 m-t-xs">-->
      <p-table [value]="classificationList" [responsive]="false" class="col-12" [reorderableColumns]=" true">
        <ng-template pTemplate="caption">
          <div style="text-align: center; width: 100%">
            <!--Idenditificador de Lote: {{classificationList[0].procurementProjectLot?.lotId }};
            Nº de Lote: {{classificationList[0].procurementProjectLot?.lotNumber}};
            Lote: {{classificationList[0].procurementProjectLot?.description}}
            {{classificationList[0].procurementProjectLot?.lotNumber}}
            {{classificationList[0].procurementProjectLot?.description}}-->
            <span *ngIf="classificationList[0] === undefined || classificationList[0] === null">No hay datos sobre este
              lote</span>
            <span *ngIf="classificationList[0]?.procurementProjectLot === undefined">Nombre del lote sin
              identificar</span>
            <span *ngIf="classificationList[0]?.procurementProjectLot?.lotId == 0">Expediente sin lotes</span>
            <span
              *ngIf="classificationList[0]?.procurementProjectLot?.lotId != 0">{{classificationList[0]?.procurementProjectLot?.lotNumber}}
              {{classificationList[0]?.procurementProjectLot?.description}}</span>

          </div>
        </ng-template>
        <ng-template pTemplate="header" *ngIf="classificationList[0] !== null && classificationList[0] !== undefined">
          <tr>
            <th [style.width]="'8%'" class="text-center">Nº posición</th>
            <th [style.width]="'30%'" class="text-left">Empresa (NIF + razón social)</th>
            <th [style.width]="'8%'" class="text-right">Total puntos</th>
            <th [style.width]="'10%'" class="text-left">Estado</th>
            <th [style.width]="'8%'" class="text-center">Empate</th>
            <th [style.width]="'8%'" class="text-center">Baja temeraria</th>
            <th [style.width]="'20%'" class="text-left">Fecha-hora registro</th>
            <th [style.width]="'8%'" class="text-center" *ngIf="isVisiblePropuestaAdj()">Propuesta de Adj</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
          <tr
            *ngIf="(classificationList[0] === null || classificationList[0] === undefined || classificationList[0].tenderLot === undefined)"
            class="text-center">
            <td colspan="8">{{ 'General.noData' | translate }}</td>
          </tr>
          <tr
            *ngIf="(classificationList[0] !== null && classificationList[0] !== undefined && classificationList[0].tenderLot)">
            <td class="text-center" *ngIf="!isEditablePosicion(data)">
              <span class="p-column-title">Nº posición</span>
              <p-inputNumber [disabled]="true" [(ngModel)]="data.tenderLot?.tenderEvaluation.classificationPosition">
                <!-- Posición clasificación-->
              </p-inputNumber>
            </td>
            <td class="text-center" *ngIf="isEditablePosicion(data)">
              <span class="p-column-title">Nº posición</span>
              <p-inputNumber [styleClass]="'input-danger'" [min]="1" [max]="100"
                [(ngModel)]="data.tenderLot?.tenderEvaluation.tiebreakPosition"><!-- Posición desempate-->
              </p-inputNumber>
            </td>
            <td>
              <span class="p-column-title">Empresa (NIF + razón social)</span>
              <span
                *ngIf="data.tender?.tendererParty?.company?.commercialName === undefined || data.tender?.tendererParty?.company?.commercialNames===''">{{data.tender?.tendererParty?.company?.taxIdentifier}}</span>
              <span
                *ngIf="data.tender?.tendererParty?.company?.commercialName !== undefined && data.tender?.tendererParty?.company?.commercialNames !==''">
                {{data.tender?.tendererParty?.company?.taxIdentifier}} -
                {{data.tender?.tendererParty?.company?.commercialName}} </span>
            </td>
            <td class="text-right">
              <span class="p-column-title">Total puntos</span> {{data.tenderLot?.tenderEvaluation?.awardTotalScore |
              currency:' ' }}
            </td>
            <td class="text-left">
              <span class="p-column-title">Estado</span>
              {{getDescripctionStatusCode(data.tenderLot?.tenderEvaluation.admissionStatus.statusCode)}}
            </td>
            <td class="text-center"
              [ngClass]="(isDesempatar() && data.tenderLotClassificationDataDisplay.tiedPosition)? 'font-bold text-danger': undefined">
              <span class="p-column-title">Empate</span>
              <span class="text-uppercase"
                *ngIf="data.tenderLot?.tenderEvaluation?.classificationPosition !== undefined && data.tenderLotClassificationDataDisplay.tiedPosition">{{'General.yes'
                | translate}}</span>
              <span class="text-uppercase"
                *ngIf="data.tenderLot?.tenderEvaluation?.classificationPosition !== undefined && !data.tenderLotClassificationDataDisplay.tiedPosition">{{'General.no'
                | translate}}</span>
            </td>
            <td class="text-center">
              <span class="p-column-title">Baja temeraria</span>
              <span class="text-uppercase">
                {{
                (
                (!data.tenderLot?.tenderEvaluation?.isConsideredAsAbnormallyLowTender ||
                data.tenderLot?.tenderEvaluation?.isConsideredAsAbnormallyLowTender === TriStateDTO.UNDEFINED) ?
                'General.undefined'
                :
                (
                (data.tenderLot?.tenderEvaluation?.isConsideredAsAbnormallyLowTender === TriStateDTO.YES) ?
                'General.yes' : 'General.no'
                )
                )
                | translate
                }}
              </span>
            </td>
            <td class="text-left">
              <span class="p-column-title">Fecha-hora registro</span>
              {{data.tender?.tenderSubmission?.submissionDate | date: 'dd/MM/yyyy HH:mm:ss'}}
            </td>
            <td class="text-center" *ngIf="isVisiblePropuestaAdj()">
              <span class="p-column-title">Propuesta de Adj</span>
              <p-checkbox name="groupAwardProposal" [disabled]="isEditablePropuestaAdj(data)" [binary]="true"
                (onChange)="selectAwardProposal($event,data)" class="col-1 p-0 ml-2 mb-2"
                [(ngModel)]="data.tenderLot?.tenderEvaluation.awardProposal"></p-checkbox>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr class="text-center">
            <td colspan="8">{{ 'General.noData' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <!--<ng-template #noClassification>
      <div class="row p-3 m-t-xs">
        No tenemos información del Lote - EEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE
      </div>
    </ng-template>-->
  </div>
</ng-template>

<ng-template #recorremosMap2>
  <!-- Entramos en template: recorremosMap2-->
  <div *ngFor="let data of tenderLotClassificationsMapTableRowModel | keyvalue">
    <ng-container *ngTemplateOutlet="templateClassification;
      context: {tenderLotClassificationsTableRowModelParam: debugRecorremosMap2(data.value)}"></ng-container>
    <!--<div *ngFor="let tenderLotClassification of datas.value">
      <ng-container *ngTemplateOutlet="templateClassification;
      context: {tenderLotClassificationsTableRowModelParam: debugRecorremosMap2(tenderLotClassification)}">
      </ng-container>
    </div>-->
  </div>
</ng-template>

<!--
<ng-template #recorremosMap>
  -> Entramos en template: recorremosMap
  <div *ngFor="let datas of tenderLotClassificationsMapTableRowModel | keyvalue">
    {{datas.key}}
    <li *ngFor="let data of datas.value | keyvalue">
      -> {{data.value}} - {{data.value.procurementProjectLot?.description}} -
      -> {{data.value.tenderLot?.tenderEvaluation?.classificationPosition}} -
      -> {{data.value.tender?.tendererParty?.company?.commercialName}}
    </li>
  </div>
</ng-template> -->



<!--
<ng-template #example_Expandable_Row_Groups>
  -> Entramos en : #example_Expandable_Row_Group
  -> load: {{load}}
  <div class="card" *ngIf="this.load">
    <h5>Expandable Row Groups</h5>
    <p>Group customers by their representative.</p>
    <p-table [value]="tenderLotClassificationsTableRowModel" sortMode="single"
      dataKey="procurementProjectLot?.lotNumber" rowGroupMode="subheader" groupRowsBy="procurementProjectLot?.lotNumber"
      responsiveLayout="scroll">
      <ng-template pTemplate="header">
        -> Entramos en pTemplate: header
        <tr>
          <th>Lote</th>
          <th>Nº posición</th>
          <th>Empresa (NIF + razón social)</th>
          <th>Total puntos</th>
          <th>Estado</th>
          <th>Empate</th>
          <th>Baja temeraria</th>
          <th>Fecha-hora registro</th>
          <th>Propuesta de Adj</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="groupheader" let-tenderLotClassificationTableRowModel let-rowIndex="rowIndex"
        let-expanded="expanded">
        -> Entramos en pTemplate: groupheader
        <tr>
          <td colspan="5">
            <button type="button" pButton pRipple [pRowToggler]="tenderLotClassificationTableRowModel"
              class="p-button-text p-button-rounded p-button-plain p-mr-2"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            <span class="p-text-bold p-ml-2">
              {{tenderLotClassificationTableRowModel.procurementProjectLot.descriptionr}}
            </span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-tenderLotClassificationTableRowModel let-rowIndex="rowIndex">
        -> Entramos en pTemplate: rowexpansion
        <tr>
          <td>
            {{tenderLotClassificationTableRowModel.procurementProjectLot?.lotNumber}}
            -
            {{tenderLotClassificationTableRowModel.procurementProjectLot?.description}}
          </td>
          <td>
            {{tenderLotClassificationTableRowModel.tenderLot?.tenderEvaluation?.classificationPosition}}
          </td>
          <td>
            {{tenderLotClassificationTableRowModel.tender?.tendererParty?.company?.taxIdentifier}}
            -
            {{tenderLotClassificationTableRowModel.tender?.tendererParty?.company?.commercialName}}
          </td>
          <td>
            {{tenderLotClassificationTableRowModel.tenderLot?.tenderEvaluation?.awardTotalScore}}
          </td>
          <td>
            {{tenderLotClassificationTableRowModel.tenderLot?.tenderEvaluation?.admissionStatus?.statusCode}}
          </td>
          <td>
            {{tenderLotClassificationTableRowModel.tenderLotClassificationDataDisplay?.tiedPosition}}
          <td>
            {{tenderLotClassificationTableRowModel.tenderLot?.tenderEvaluation?.isConsideredAsAbnormallyLowTender}}
          </td>
          <td>
            {{tenderLotClassificationTableRowModel.tenderLot?.tenderEvaluation?.classificationDate |
            date:'dd/MM/yyyy'}}
          </td>
          <td>
            {{tenderLotClassificationTableRowModel.tenderLot?.tenderEvaluation?.awardProposal}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</ng-template> -->